<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" >
        <div class="card-panel-icon-wrapper icon-all-order">
          <svg-icon icon-class="all-order" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            订单金额
          </div>
          <count-to :start-val="0" :end-val="chartData.totalMoney" :duration="100" :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            订单总数
          </div>
          <count-to :start-val="0" :end-val="chartData.totalNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-refund">
          <svg-icon icon-class="refund" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            退款金额
          </div>
          <count-to :start-val="0" :end-val="chartData.refundMoney" :duration="100" :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            退款总数
          </div>
          <count-to :start-val="0" :end-val="chartData.refundNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-comission">
          <svg-icon icon-class="comission" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            佣金金额
          </div>
          <count-to :start-val="0" :end-val="chartData.commissionMoney" :duration="100" :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            佣金总数
          </div>
          <count-to :start-val="0" :end-val="chartData.commissionNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-wechat">
          <svg-icon icon-class="wechat" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            公众号充值金额
          </div>
          <count-to :start-val="0" :end-val="chartData.wxMoney" :duration="100"  :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            公众号充值数
          </div>
          <count-to :start-val="0" :end-val="chartData.wxNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-h5">
          <svg-icon icon-class="h5" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            H5充值金额
          </div>
          <count-to :start-val="0" :end-val="chartData.webMoney" :duration="100" :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            H5充值总数
          </div>
          <count-to :start-val="0" :end-val="chartData.webNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-alipay">
          <svg-icon icon-class="alipay" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            支付宝充值金额
          </div>
          <count-to :start-val="0" :end-val="chartData.alipayMoney" :duration="100" :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            支付宝充值总数
          </div>
          <count-to :start-val="0" :end-val="chartData.alipayNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-balance">
          <svg-icon icon-class="balance" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            余额充值金额
          </div>
          <count-to :start-val="0" :end-val="chartData.balanceMoney" :duration="100" :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            余额充值总数
          </div>
          <count-to :start-val="0" :end-val="chartData.balanceNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-rpc">
          <svg-icon icon-class="rpc" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            补卡充值金额
          </div>
          <count-to :start-val="0" :end-val="chartData.newMoney" :duration="100" :decimals="2" class="card-panel-num" />
          <div class="card-panel-min-text">
            补卡充值总数
          </div>
          <count-to :start-val="0" :end-val="chartData.newNum"  class="card-panel-min-num" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  components: {
    CountTo
  },
  data() {
    return {
      chartData: {}
    }
  },
  props: {
    panelData: {
      type: Object,
      required: true
    }
  },
  watch: {
    panelData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
      immediate: true
    }
  },
  methods: {
    setOptions(data){
        this.chartData = data;
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-all-order{
        background: #36a3f7;
      }
      .icon-refund {
        background: #f124c7;
      }
      .icon-comission {
        background: #f4516c;
      }
      .icon-wechat {
        background: #34bfa3;
      }
      .icon-h5 {
        background: #1296db;
      }
      .icon-alipay {
        background: #409EFF;
      }
      .icon-balance {
        background: #73C0DE;
      }
      .icon-rpc {
        background: #3BA272;
      }


    }


    .icon-all-order {
      color: #36a3f7;
    }
    .icon-refund {
      color: #f124c7;
    }
    .icon-comission {
      color: #f4516c;
    }

    .icon-wechat {
      color: #34bfa3
    }
    .icon-h5 {
      color: #1296db
    }
    .icon-alipay {
      color: #409EFF
    }
    .icon-balance {
      color: #73C0DE
    }
    .icon-rpc {
      color: #3BA272
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      // margin: 26px;
      margin: 5px;
      margin-left: 0px;
      margin-right: 20px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-min-text {
        line-height: 20px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
      }

      .card-panel-num {
        font-size: 20px;
        color: #f4516c;
      }
      .card-panel-min-num {
        font-size: 14px;
        color: #34bfa3;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
